import { render } from "./FamilyDetail.vue?vue&type=template&id=61a4d791"
import script from "./FamilyDetail.vue?vue&type=script&lang=js"
export * from "./FamilyDetail.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/amatra-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__